import React from "react";

import { ChevronLeft, ChevronRight } from "lucide-react";

// ── Design tokens (mirrors the SCSS tokens) ───────────────────────────────────
const T = {
  brand: "#024e5a",
  brandLight: "#eaf5f7",
  textPrimary: "#0f172a",
  textMuted: "#334155",
  textDim: "#64748b",
  border: "#cbd5e1",
  bgHover: "#f1f5f9",
  radius: 10,
};

// Status badge config — keys are title-case, lookup is normalised
const BADGE = {
  Positive: { bg: "#ecfdf5", color: "#047857", label: "Positive" },
  Pending:  { bg: "#fffbeb", color: "#b45309", label: "Pending"  },
  Negative: { bg: "#fef2f2", color: "#b91c1c", label: "Negative" },
};

const getBadge = (val) => {
  if (!val) return BADGE["Positive"];
  const key = val.charAt(0).toUpperCase() + val.slice(1).toLowerCase();
  return BADGE[key] ?? BADGE["Positive"];
};

export default function Sidebar({ SidebarData, tab, handleSection , type, collapsed, setCollapsed}) {
  if (!SidebarData || SidebarData.length === 0) return null;

  return (
    <>
      <style>{`
        .wogom-sidebar-toggle-btn:hover {
          background-color: #267dff !important;
          border-color: #267dff !important;
          color: #ffffff !important;
          box-shadow: 0 3px 10px rgba(38, 125, 255, 0.3) !important;
        }
      `}</style>
      <div 
        className="custom-sidebar-new" 
        style={{
          position: 'fixed',
          top: type === 'allApplication' ? '133px' : '157px',
          width: collapsed ? "60px" : "232px",
          transition: "width 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
          overflow: "visible",
        }}
      >
        {/* Circle collapse toggle button centered on right border */}
        <button
          onClick={() => setCollapsed(!collapsed)}
          style={{
            position: "absolute",
            top: "12px",
            right: "-13px",
            width: "26px",
            height: "26px",
            borderRadius: "50%",
            border: "1.5px solid #cbd5e1",
            backgroundColor: "#ffffff",
            color: "#94a3b8",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            flexShrink: 0,
            outline: "none",
            boxShadow: "0 2px 6px rgba(15,23,42,0.08)",
            zIndex: 101,
            transition: "background 0.15s, border-color 0.15s, color 0.15s",
          }}
          title={collapsed ? "Expand sidebar" : "Collapse sidebar"}
          className="wogom-sidebar-toggle-btn"
        >
          {collapsed ? <ChevronRight size={12} /> : <ChevronLeft size={12} />}
        </button>

        {SidebarData.map((item, idx) => {
          const Icon     = item?.icon;
          const isActive = item?.id === tab;
          const badge    = getBadge(item?.vals);

          return (
            <div
              key={idx}
              className={`sidebar-items${isActive ? " active" : ""}`}
              onClick={() => handleSection(item?.id)}
              title={item?.name}
              style={{
                justifyContent: collapsed ? "center" : "space-between",
                padding: collapsed ? "11px 0" : "11px 14px",
              }}
            >
              {/* Icon + label */}
              <div 
                className="sidebar-item-left"
                style={{
                  justifyContent: collapsed ? "center" : "flex-start",
                  gap: collapsed ? "0" : "10px",
                }}
              >
                {Icon && (
                  <Icon
                    style={{
                      color: isActive ? '#ffffff' : T.textDim,
                      strokeWidth: isActive ? 2.2 : 1.6,
                      width: 15,
                      height: 15,
                      flexShrink: 0,
                      transition: "color .13s",
                    }}
                  />
                )}
                {!collapsed && (
                  <h5
                    style={{
                      color: isActive ? '#ffffff' : T.textMuted,
                      fontWeight: isActive ? 600 : 400,
                      transition: "color .13s, font-weight .13s",
                      fontSize: window.innerWidth < 1800 ? '13px' : '14px',
                      marginLeft: "4px",
                    }}
                  >
                    {item?.name}
                  </h5>
                )}
              </div>

              {/* Status badge */}
              {/* {!collapsed && item?.vals && (
                <h6 style={{ background: badge.bg, color: badge.color }}>
                  {badge.label}
                </h6>
              )} */}
            </div>
          );
        })}
      </div>
    </>
  );
}
